export var calculateMarginMapper = function (data) {
    var result = {};
    if (data) {
        result.exposure_margin = data.exMgn;
        result.prm = data.prm;
        result.span_margin = data.spMgn;
        result.total = data.tot;
        result.current_exp = data.cxp;
        result.current_span = data.cs;
        result.current_tot = data.ctot;
    }
    return result;
};
